(() => {
  const optimizeFirstPaint = document.documentElement.hasAttribute('data-er-pdp-performance');
  let launcherNode = null;
  const entrySelector = '[data-rewards-open]';
  const pageLinkSelector = '[data-rewards-page-link]';
  const isRewardsPage = window.location.pathname.replace(/\/+$/, '').endsWith('/pages/rewards-terms-and-conditions');
  document.documentElement.toggleAttribute('data-rewards-page', isRewardsPage);
  const launcherSelector = '.yotpo-floater-widget-layout .yotpo-banner-layout[role="button"]';
  const drawerSelector = '.yotpo-floater-widget-layout .yotpo-drawer-layout';
  let drawer = null;
  let drawerObserver = null;
  let returnFocus = null;
  let wasOpen = false;
  let scanPending = false;

  const isOpen = () => drawer?.isConnected && getComputedStyle(drawer).display !== 'none';

  const syncEntries = () => {
    const open = Boolean(isOpen());
    document.querySelectorAll(entrySelector).forEach(entry => {
      entry.setAttribute('aria-controls', drawer.id);
      entry.setAttribute('aria-expanded', String(open));
    });
    if (wasOpen && !open && returnFocus?.isConnected) {
      // A mobile menu entry becomes hidden after opening; focus its menu toggle.
      const menu = returnFocus.closest('#MobileMenu');
      const target = menu?.hidden ? document.querySelector('[data-menu-toggle]') : returnFocus;
      target?.focus({ preventScroll: true });
      returnFocus = null;
    }
    wasOpen = open;
  };

  const bindDrawer = () => {
    const nextDrawer = document.querySelector(drawerSelector);
    launcherNode = document.querySelector(launcherSelector);
    if (!nextDrawer || !launcherNode || !document.querySelector(`${entrySelector}, ${pageLinkSelector}`)) {
      document.documentElement.removeAttribute('data-rewards-fixed-entry');
      return;
    }
    if (nextDrawer !== drawer) {
      drawerObserver?.disconnect();
      drawer = nextDrawer;
      if (!drawer.id) drawer.id = 'ember-rewards-drawer';
      drawerObserver = new MutationObserver(syncEntries);
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    syncEntries();
    // Navigation opens the introduction page. Its native launcher stays visible;
    // shopping pages keep only the ordinary Rewards navigation links.
    document.documentElement.toggleAttribute('data-rewards-fixed-entry', !isRewardsPage);
  };

  const observer = new MutationObserver(() => {
    if (optimizeFirstPaint && drawer?.isConnected && launcherNode?.isConnected) return;
    if (scanPending) return;
    scanPending = true;
    requestAnimationFrame(() => {
      scanPending = false;
      bindDrawer();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  bindDrawer();

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const entry = event.target.closest(entrySelector);
    if (!entry) return;
    bindDrawer();
    const launcher = document.querySelector(launcherSelector);
    if (!drawer?.isConnected || !launcher) {
      // Preserve the real link as a fallback when the provider has not loaded.
      const status = document.getElementById('rewards-load-status');
      if (status) status.hidden = false;
      return;
    }
    event.preventDefault();
    returnFocus = entry;
    const menu = document.getElementById('MobileMenu');
    if (menu && !menu.hidden) document.querySelector('[data-menu-toggle]')?.click();
    if (!isOpen()) launcher.click();
    requestAnimationFrame(() => {
      syncEntries();
      drawer.querySelector('button, a, [tabindex="0"]')?.focus({ preventScroll: true });
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !isOpen()) return;
    const close = drawer.querySelector('.yotpo-close-icon');
    if (close) {
      event.preventDefault();
      close.click();
    }
  });
})();
